import { render, staticRenderFns } from "./ClientStatusField.vue?vue&type=template&id=4b3816e8&"
import script from "./ClientStatusField.vue?vue&type=script&lang=js&"
export * from "./ClientStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports